import { render, staticRenderFns } from "./GeneralInterfacesEditorRedirector.vue?vue&type=template&id=1ea1a57a&scoped=true&"
import script from "./GeneralInterfacesEditorRedirector.vue?vue&type=script&lang=ts&"
export * from "./GeneralInterfacesEditorRedirector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea1a57a",
  null
  
)

export default component.exports